import { faSync } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC, ReactNode } from 'react';
import { NewDesignToggleSkeleton } from 'src/components/layout/app-shell/new-design-toggle-skeleton';
import { TopBar } from 'src/components/layout/app-shell/top-bar';
import { Logo } from 'src/components/media-and-icons/logo';

export const AppShellSkeleton: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  return (
    <div
      className={`
        grid h-dvh
        not-md:pt-5xl
        md:grid-cols-[auto_1fr]
        legacy:hidden
      `}
    >
      {/* TOPBAR */}
      <div
        className={`
          absolute top-0 z-1 w-screen
          not-md:shadow-elevation-sm
        `}
      >
        <NewDesignToggleSkeleton />
        <TopBar open={false} />
      </div>

      {/* NOT MOBILE: SIDEBAR */}
      <div
        className={`
          relative hidden w-(--sidebar-width-collapsed)
          bg-background-sidebar-default pt-md
          md:block md:h-dvh md:pt-(--sidebar-padding)
          xl:w-(--sidebar-width)
        `}
      >
        <div
          className={`
            absolute -right-md h-2xl w-2xl rounded-full
            bg-background-sidebar-default p-xs shadow-elevation-sm
          `}
        />

        <div
          className={`
            flex h-2xl min-h-2xl overflow-hidden
            px-[calc(var(--sidebar-padding)+var(--spacing-md))]
          `}
        >
          <div className="flex h-2xl items-center">
            <Logo
              mode="default"
              className={`
                h-2xl min-h-2xl w-[110px] min-w-[110px]
                not-legacy:hidden not-legacy:xl:block
              `}
            />
            <Logo
              mode="icon"
              className={`
                h-[20px] min-h-[20px] w-[17px] min-w-[17px] object-contain
                not-legacy:hidden not-legacy:not-xl:block
              `}
            />
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div
        className={`
          bg-background-default px-[calc(var(--spacing-xl)+var(--spacing-lg))]
          py-2xl
          md:px-3xl
        `}
      >
        {children ?? (
          <div className="flex justify-center" aria-label="Loading...">
            <div
              className={`
                h-[14px] w-[14px] animate-[spin_800ms_linear_infinite]
              `}
            >
              <FontAwesomeIcon icon={faSync} className="block!" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
